import { render, staticRenderFns } from "./PromotionsOverviewPage.vue?vue&type=template&id=27daf6e1&"
import script from "./PromotionsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./PromotionsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsOverviewPage.vue?vue&type=style&index=0&id=27daf6e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports